import Logger from '../../../../../ui-kitchen/src/utils/logger';
import { getVenue } from '../../../../../ui-kitchen/src/api';
import { venueTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import { ALL_DAY, ISO_DATE_FORMAT } from '../../../../../ui-kitchen/src/constants/resyCore';
import { getURLSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';
import { getLocationUrl } from '../../../../../ui-kitchen/src/utils/locationUtils';

// Must preserve signature for loadReservations(venueId, selectedDate, selectedQuantity) which is passed along as a Notify-component prop
const getLoadReservations = ({
  getVenueReservationsThunk,
  selectedTime,
  serviceDayCutoff,
  setReservationsByServicePeriod,
}) => (venueId, selectedDate, selectedQuantity) => {
  setReservationsByServicePeriod(null);
  const searchParams = getURLSearchParams();
  const resyToken = searchParams.get('resyToken');
  const params = {
    venue_id: venueId,
    day: moment(selectedDate).format(ISO_DATE_FORMAT),
    party_size: selectedQuantity,
    time_filter: selectedTime === ALL_DAY ? undefined : moment(selectedTime, 'HHmm').format('HH:mm'),
    resy_token: resyToken,
    service_day_cutoff: serviceDayCutoff,
  };
  return getVenueReservationsThunk({ params });
};

const loadVenueInventory = ({
  getVenueInventoryThunk, venueId, selectedQuantity, forcedReload = false,
}) => {
  const params = {
    venue_id: venueId,
    num_seats: selectedQuantity,
    start_date: moment().format(ISO_DATE_FORMAT),
    end_date: moment().add(1, 'year').format(ISO_DATE_FORMAT),
  };
  return getVenueInventoryThunk({ params, forcedReload });
};

const loadVenue = ({ locationId, venueSlug, venueId }) => {
  const requestParams = {};
  if (venueId) {
    requestParams.id = venueId;
  } else if (locationId && venueSlug) {
    requestParams.url_slug = venueSlug;
    requestParams.location = locationId;
  } else {
    Logger.error(`VenueDetails loadVenue bad path: url: ${getLocationUrl()}`, venueId);
  }
  return getVenue(requestParams).then((data) => venueTransform(data));
};

export {
  loadVenueInventory,
  getLoadReservations,
  loadVenue,
};
